import React from 'react';
import styled from 'styled-components';
import { Button as MuiButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';

import * as theme from '../../theme';

interface ButtonProps {
    icon: any;
    buttonColor: string;
}

const Button = (props) => {
    const { variant, children, icon, color, ...rest } = props;

    const getIcon = () => {
        switch (variant) {
            case 'delete':
                return <DeleteIcon />;

            case 'cancel':
                return <CancelIcon />;

            case 'save':
                return <SaveIcon />;

            case 'add':
                return <AddIcon />;

            default:
                return '';
        }
    };

    return (
        <StyledMuiButton {...rest} buttonColor={color} icon={icon} variant={'contained'}>
            {children}
        </StyledMuiButton>
    );
};

export default Button;

const StyledMuiButton = styled(MuiButton)<ButtonProps>`
    && {
        border-radius: 0;
        box-shadow: none;
        background: ${(props) => (props.buttonColor ? props.buttonColor : theme.colors.blue.main)};
        color: #fff;
        border: 1px solid ${(props) => (props.buttonColor ? props.buttonColor : theme.colors.blue.main)};
        min-width: unset;
        min-height: 36px;

        &.Mui-disabled {
            border: 1px solid rgb(224, 224, 224);
        }

        &:hover {
            opacity: 0.85;
            background-color: ${(props) => (props.buttonColor ? props.buttonColor : theme.colors.blue.main)};
            box-shadow: none;
        }
    }

    & > svg {
        margin-right: 4px;
    }

    span {
        width: ${(props) => props.icon && `100px`};
    }
`;
